import { useNavigate } from 'react-router-dom';
import NavbarComponent from '../landing_page/landing_page_components/NavbarComponent';

export default function PrivacyPolicy() {
    const navigate = useNavigate();

    return (
        <>
            <div className="pt-[1.88rem] px-[2.5rem] w-full">
                <NavbarComponent handleNavigate={() => navigate('/')} />
            </div>
            <div className="flex flex-col w-full px-[5rem] py-[3rem]">
                <span className="heading_1">Privacy Policy</span>
                <span className="paragraph_1 mt-[1.5rem]">Chamify Africa</span>

                <span className="mt-[1.5rem]">
                    Chamify Africa values your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, store, and
                    protect your information when you use our platform.
                </span>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">1. Information We Collect</span>
                    <span className="label_2">We may collect:</span>
                    <span className="paragraph_1">● Full name</span>
                    <span className="paragraph_1">● Phone number</span>
                    <span className="paragraph_1">● Email address</span>
                    <span className="paragraph_1">● Identification details where necessary</span>
                    <span className="paragraph_1">● Financial and transaction-related information</span>
                    <span className="paragraph_1">● Device and usage information</span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">2. How We Use Your Information</span>
                    <span className="label_2">Your information may be used to:</span>
                    <span className="paragraph_1">● Create and manage user accounts</span>
                    <span className="paragraph_1">● Facilitate savings group operations</span>
                    <span className="paragraph_1">● Improve platform functionality and user experience</span>
                    <span className="paragraph_1">● Communicate updates, notifications, and support</span>
                    <span className="paragraph_1">● Enhance security and prevent fraud</span>
                    <span className="paragraph_1">● Comply with legal and regulatory obligations</span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">3. Data Protection</span>
                    <span className="label_2">
                        We implement reasonable technical and organizational measures to protect your information from unauthorized access, misuse, loss, or disclosure.
                    </span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">4. Sharing of Information</span>
                    <span className="label_2">Chamify Africa does not sell personal information. We may share information with:</span>
                    <span className="paragraph_1">● Authorized service providers</span>
                    <span className="paragraph_1">● Payment processing partners</span>
                    <span className="paragraph_1">● Regulatory authorities where legally required</span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">5. Cookies and Analytics</span>
                    <span className="label_2">
                        Our platform may use cookies and analytics tools to improve performance, monitor usage, and personalize user experience.
                    </span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">6. User Rights</span>
                    <span className="label_2">Users may:</span>
                    <span className="paragraph_1">● Request access to their personal information</span>
                    <span className="paragraph_1">● Request correction of inaccurate information</span>
                    <span className="paragraph_1">● Request deletion of their data where applicable</span>
                    <span className="paragraph_1">● Withdraw consent for certain communications</span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">7. Data Retention</span>
                    <span className="label_2">
                        We retain personal information only for as long as necessary to provide services, comply with legal obligations, and resolve disputes.
                    </span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">8. Third-Party Links</span>
                    <span className="label_2">
                        Chamify Africa may contain links to third-party websites or services. We are not responsible for the privacy practices of external platforms.
                    </span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">9. Policy Updates</span>
                    <span className="label_2">
                        This Privacy Policy may be updated periodically. Continued use of the platform after changes indicates acceptance of the updated policy.
                    </span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">10. Contact Us</span>
                    <span className="label_2">If you have questions regarding this Privacy Policy or your personal data, contact:</span>
                    <span className="paragraph_1">Email: chamify@spa-limited.com</span>
                    <span className="paragraph_1">Phone: 0141940343</span>
                    <span className="paragraph_1">Website: https://chamify.africa/</span>
                </div>

                <span className="paragraph_2 mt-[3rem]">Thank you for using Chamify!</span>
            </div>
        </>
    );
}
